<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M37.5 44h-27a2 2 0 01-2-2V21a2 2 0 012-2H13v-3.68a11.22 11.22 0 019.94-11.27A11 11 0 0135 15v4h2.5a2 2 0 012 2v21a2 2 0 01-2 2zm-26-3h25V22H32v-7a8 8 0 00-16 0v7h-4.5z"/><path d="M30.07 22H17.93v-6.43a6.07 6.07 0 0112.14 0zm-9.14-3h6.14v-3.43a3.07 3.07 0 00-6.14 0zM27.84 38h-7.68l1-5a4.5 4.5 0 115.72 0zm-5.25-2h2.82l-.78-4 .62-.36a2.5 2.5 0 10-2.5 0l.62.36z"/></svg>